import { CURRENCY_SHORT_SYMBOLS } from '@xanadu/ui-shared/constants';
import shared18Next from '../../../../javascripts/i18n';
import { dangerouslyGetState } from '../../configureStore';

const { i18n = {} } = shared18Next || {};
const { t = (v) => v } = i18n;

const data = {};

const getOnboardingImagePath = (step, activeLanguage) =>
  `/assets/images/onboarding/predictions/step${step}_${activeLanguage}.png`;

const buildPredictionsStepContent = ({ step, title, subtitle, imagePath, sections }) => ({
  title: `
    <div class="predictions-onboarding-step__headerContent" style="background-image: url(${imagePath})">
      <span class="predictions-onboarding-step__title">${title}</span>
      <span class="predictions-onboarding-step__subtitle">${subtitle}</span>
    </div>
  `,
  content: `
    <div class="predictions-onboarding-step predictions-onboarding-step--${step}">
      <button id="onboarding-close-btn-${step}" class="onboarding-close-btn"></button>
      <div class="predictions-onboarding-step__body">
        ${sections.map((section) => `<div>${section}</div>`).join('')}
      </div>
    </div>
  `,
});

export const VIDEO_LIST = [
  {
    image: '/assets/images/onboarding/exchange-layout.jpg',
    url: 'https://www.youtube.com/embed/mLyxX5vZQ-I',
  },
  {
    image: '/assets/images/onboarding/commissions.jpg',
    url: 'https://www.youtube.com/embed/EYeGBUNtEao',
  },
  {
    image: '/assets/images/onboarding/exchange-vs-sportsbook.jpg',
    url: 'https://www.youtube.com/embed/EMwttgEzwrc',
  }
];

export const RESTRICTED_PAGES = [
  '/page',
  '/promo',
  '/login',
  '/promotions',
  '/registration',
  '/reset-password',
  '/update-password',
];


export function updateTranslations() {
  const { language: activeLanguage } = i18n;
  const currency = dangerouslyGetState().getIn(['application', 'defaultCurrency']);
  const userCurrency = dangerouslyGetState().getIn(['user', 'currency']);
  const activeCurrency = userCurrency || currency;
  let currencyShortSymbol = '¤';
  if (activeCurrency) {
    currencyShortSymbol = CURRENCY_SHORT_SYMBOLS[activeCurrency];
  }

  data.STEPS_CONTENT = [
    {
      title: `1. ${t('Back & Lay')}`,
      content: `
        <div class="driver-popover-description__step1">
          <button id="onboarding-close-btn-1" class="onboarding-close-btn"></button>
          <img
            alt="1. ${t('Back & Lay')}"
            src="/assets/images/onboarding/step1_${activeLanguage}.png"
          />
          <div><b>${t('Back')}</b> - ${t('A standard bet. Back a team, player or a horse, and if they win, you win.')}</div>
          <br />
          <div><b>${t('Lay')}</b> - ${t('A lay bet is betting on a team, player or horse NOT winning. If you lay a horse or a team, and they lose or draw, your lay bet wins. If you place a lay bet and your selection wins, your lay bet loses.')}</div>
        </div>
      `
    },
    {
      title: `2. ${t('Odds & Liquidity')}`,
      content: `
        <div class="driver-popover-description__step2">
          <button id="onboarding-close-btn-2" class="onboarding-close-btn"></button>
          <img
            alt="2. ${t('Odds & Liquidity')}"
            src="/assets/images/onboarding/step2_${activeLanguage}.png"
          />
          <div><b>${t('Odds')}</b> - ${t("The current odds on offer for this bet. Don't like the odds on offer? Make your own offer with the odds you want and see if someone will take your bet.")}</div>
          <br />
          <div>${(t("Not familiar with decimal odds? No worries, it's simple. For example, if you win a ¤10 bet at odds of 3.0, you would receive ¤30, which includes your original stake of ¤10, plus ¤20 of winnings.")).replaceAll('¤', currencyShortSymbol)}</div>
          <br />
          <div><b>${t('Liquidity')}</b> - ${t('The amount currently available to wager. Again, you can offer more, and see if another player will take the bet.')}</div>
        </div>
      `
    },
    {
      title: `3. ${t('Back Bets')}`,
      content: `
        <div class="driver-popover-description__step3">
          <button id="onboarding-close-btn-3" class="onboarding-close-btn"></button>
          <img
            alt="3. ${t('Back Bets')}"
            src="/assets/images/onboarding/step3_${activeLanguage}.png"
          />
          <div><b>${t('Back')}</b> - ${t('The odds for your bet. You can either take the odds available in the market, adjust up or down, or enter your own odds.')}</div>
          <br />
          <div>${t('The higher the odds, the higher the winnings.')}</div>
          <br />
          <div><b>${t('Stake')}</b> - ${t('For a back bet, this is the amount you will be staking, and will lose if the bet loses.')}</div>
          <br />
          <div><b>${t('Profit')}</b> - ${t('The amount of profit you will make if your back bet wins. Your stake will also be returned.')}</div>
        </div>
      `
    },
    {
      title: `4. ${t('Lay Bets')}`,
      content: `
        <div class="driver-popover-description__step4">
          <button id="onboarding-close-btn-4" class="onboarding-close-btn"></button>
          <img
            alt="4. ${t('Lay Bets')}"
            src="/assets/images/onboarding/step4_${activeLanguage}.png"
          />
          <div><b>${t('Lay')}</b> - ${t('The odds for your bet. As with a back bet you can either take the odds available in the market, adjust up or down, or enter your own odds. The higher the odds, the greater the risk you take.')}</div>
          <br />
          <div><b>${t('Backer Stake')}</b> - ${t('This is the amount the other player will stake, and you will win if your bet wins.')}</div>
          <br />
          <div><b>${t('Liability')}</b> - ${t('The amount you will pay out to the other player if your lay bet loses.')}</div>
        </div>
      `
    },
    {
      title: `5. ${t('Matched & Unmatched')}`,
      content: `
        <div class="driver-popover-description__step5">
          <button id="onboarding-close-btn-5" class="onboarding-close-btn"></button>
          <img
            alt="5. ${t('Matched & Unmatched')}"
            src="/assets/images/onboarding/step5_${activeLanguage}.png"
          />
          <div>${t("Not every offer you make will get matched against another player - maybe they don't like the odds you have offered, or maybe they don't want to wager so much.")}</div>
          <br />
          <div>${t('In this case either all, or part, of your offer will go unmatched.')}</div>
          <br />
          <div>${t('If this happens, you can either cancel your offer or simply wait it out. As a market fluctuates, your offer may get taken up by other players.')}</div>
        </div>
      `
    }
  ];

  data.PREDICTIONS_STEPS_CONTENT = [
    buildPredictionsStepContent({
      step: 1,
      title: `${t('Bet Yes or No')}`,
      subtitle: `${t('Pick a side - Back your opinion')}`,
      imagePath: getOnboardingImagePath(1, activeLanguage),
      sections: [
        `${t('Every Market starts with a simple question - Yes or No?')}`,
        `${t('If it&rsquo;s trending, it&rsquo;s here. Browse our markets and have your say.')}`,
      ],
    }),
    buildPredictionsStepContent({
      step: 2,
      title: `${t('Odds as a Percentage')}`,
      subtitle: `${t('Odds reflect the markets confidence')}`,
      imagePath: getOnboardingImagePath(2, activeLanguage),
      sections: [
        `${t('Prices run from 1% to 99%. This reflects the market&rsquo;s collective belief of how likely an event is to happen.')}`,
        `${t('Remember! The lower the %, the greater the payout if you&rsquo;re right.')}`
      ],
    }),
    buildPredictionsStepContent({
      step: 3,
      title: `${t('Back your Opinion')}`,
      subtitle: `${t('Follow the market, or place an offer')}`,
      imagePath: getOnboardingImagePath(3, activeLanguage),
      sections: [
        `${t('When you&rsquo;re ready to bet, place your Yes or No bet.')}`,
        `${t('If you believe the probability is higher or lower, that&rsquo;s your edge.')}`
      ],
    }),
  ];

  data.DRIVER_STEPS = [
    {
      element: '[data-hook="popular--event-0--runner-0"]',
      popover: {
        align: 'end',
        side: 'left',
        title: `1. ${t('Back & Lay')}`,
        description: data.STEPS_CONTENT[0].content,
        nextBtnText: `${t('Next')}: ${t('Odds & Liquidity')}`,
      }
    },
    {
      element: '[data-hook="popular--event-0--runner-0"]',
      popover: {
        title: `2. ${t('Odds & Liquidity')}`,
        align: 'end',
        side: 'right',
        description: data.STEPS_CONTENT[1].content,
        nextBtnText: `${t('Next')}: ${t('Back Bets')}`,
      }
    },
    {
      element: '[data-driver="offer-0"]',
      popover: {
        title: `3. ${t('Back Bets')}`,
        nextBtnText: `${t('Next')}: ${t('Lay Bets')}`,
        description: data.STEPS_CONTENT[2].content,
      }
    },
    {
      element: '[data-driver="offer-1"]',
      popover: {
        align: 'end',
        title: `4. ${t('Lay Bets')}`,
        nextBtnText: `${t('Next')}: ${t('Matched & Unmatched')}`,
        description: data.STEPS_CONTENT[3].content,
      }
    },
    {
      element: '[data-driver="open-offer-0"]',
      popover: {
        align: 'end',
        title: `5. ${t('Matched & Unmatched')}`,
        description: data.STEPS_CONTENT[4].content,
      }
    },
  ];

  data.PREDICTIONS_DRIVER_STEPS = [
    {
      element: '[data-hook="popular--trending-event-0"]',
      popover: {
        title: data.PREDICTIONS_STEPS_CONTENT[0].title,
        description: data.PREDICTIONS_STEPS_CONTENT[0].content,
        nextBtnText: `${t('Next')}`,
        align: 'end',
        side: 'top',
      },
    },
    {
      element: '[data-hook="popular--trending-event-0-prices"]',
      popover: {
        title: data.PREDICTIONS_STEPS_CONTENT[1].title,
        description: data.PREDICTIONS_STEPS_CONTENT[1].content,
        nextBtnText: `${t('Next')}`,
        align: 'end',
        side: 'right',
      },
    },
    {
      element: '[data-hook="order-pad--inputs"]',
      popover: {
        title: data.PREDICTIONS_STEPS_CONTENT[2].title,
        description: data.PREDICTIONS_STEPS_CONTENT[2].content,
        align: 'end',
        side: 'left',
      },
    },
  ];
}

// i18next seems ready -> initial fill translations
if (i18n.isInitialized) {
  updateTranslations();
}

// reset translations to new values on language change
i18n.on('languageChanged', () => {
  // we get a lng string with the new applied language here
  updateTranslations();
});

// we loaded some translation file? reset needed?!?
// https://www.i18next.com/overview/api#store-events
i18n.on('loaded', () => {
  // we get a lng object with all the loaded languages here
  updateTranslations();
});

export default data;
